import { CSSProperties } from 'react';
import { COLORS } from '~/data/ui/colors';
import theme from '~/theme';

const classes = {
  root: {
    direction: 'rtl',
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    width: '100%',
    '& li': {
      padding: 0,
      margin: 0,
      whiteSpace: 'pre',
      '&:hover': {
        backgroundColor: COLORS.primary.light2,
        cursor: 'pointer',
      },
    },
    '& li:not(:last-child)': {
      borderBottom: `1px solid ${COLORS.white.dark}`,
    },
    [theme.breakpoints.up('md')]: {
      padding: '0px',
      gap: '0px',
    },
    overflowX: 'hidden',
  } as const,
  regionLocationContainer: {
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.up('md')]: {
      paddingTop: '6px',
    },
  },
  Title: {
    padding: '0px 4px 3px',
    [theme.breakpoints.down('md')]: {
      padding: '0px 8px 8px',
    },
  },
  mainTitle: {
    [theme.breakpoints.down('md')]: {
      paddingBottom: '4px',
    },
  },
  locationContainer: {
    '& ul': {
      padding: 0,
      margin: 0,
      whiteSpace: 'pre',
      '&:hover': {
        backgroundColor: COLORS.primary.light2,
        cursor: 'pointer',
      },
    },
    '& ul:not(:last-child)': {
      borderBottom: `1px solid ${COLORS.white.dark}`,
    },
    display: 'flex',
    flexDirection: 'column',
    paddingBottom: '1px',
    [theme.breakpoints.down('md')]: {
      paddingBottom: '0px',
    },
  } as const,
  branchesOptionsContainer: {
    listStyle: 'none',
    padding: 0,
  },
};

export default classes;

export const TitleStyle: CSSProperties = {
  fontFamily: 'EricaSansFOT,GillSans',
  fontWeight: '800',
  fontSize: '16px',
  color: COLORS.black.dark,
  marginRight: '16px',
  paddingTop: '16px',
};

export const listItem = {
  '&:focus-visible': {
    background: 'rgb(229, 246, 248)',
    outline: 'none',
    border: 'none',
  },
  '&:hover': {
    background: 'rgb(229, 246, 248)',
  },
};
